import { render, staticRenderFns } from "./ContextMenu.vue?vue&type=template&id=42b3a7a8&scoped=true"
import script from "./ContextMenu.vue?vue&type=script&lang=ts"
export * from "./ContextMenu.vue?vue&type=script&lang=ts"
import style0 from "../style.scss?vue&type=style&index=0&id=42b3a7a8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b3a7a8",
  null
  
)

export default component.exports